import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { Notificacion } from "../models/notificacion";
import { global } from "../global";

@Injectable({
  providedIn: "root",
})
export class NotificacionService {
  apiUrl: string = "";
  public licencia: string;
  urlGlobal: string = '';

  private timerNotificationSubject = new BehaviorSubject<{message: string, title: string}>({message: '', title: ''});
  public timerNotification$ = this.timerNotificationSubject.asObservable();

  constructor(private http: HttpClient, private cookieService: CookieService
            
  ) {
    this.apiUrl = global.url + "notificaciones/consultarNotificacionesPorUsuario";
    this.licencia = this.cookieService.get("auth_token"); // Obtén el token de las cookies
  }

  listarNotificacionesPendientes(userId: number): Observable<any> {
    let params = new HttpParams().set("userId", String(userId));
    return this.http.get(`${this.apiUrl}`, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }

  listarNotificacionesPorUsuario(userId: number): Observable<any> {
    let params = new HttpParams().set("userId", String(userId));
    return this.http.get(`${this.apiUrl}`, {
      headers: {
        licencia: this.licencia      },
      params: params,
    });
  }

  guardarNotificacion(notificacion: Notificacion): Observable<any> {
    return this.http.post(`${global.url}notificaciones/registrar`, notificacion, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }

  eliminarNotificacion(idNotificacion: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${idNotificacion}`, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
    });
  }

  updateTimerNotification(message: string, title: string) {
    this.timerNotificationSubject.next({message, title});
  }

  formatTiempoRestante(totalSegundos: number): string {
    const segundos = Math.max(0, Math.floor(totalSegundos));
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const segs = segundos % 60;
    const mm = String(minutos).padStart(2, '0');
    const ss = String(segs).padStart(2, '0');
    return horas > 0 ? `${horas}:${mm}:${ss}` : `${minutos}:${ss}`;
  }
}
